// extracted by css-extract-rspack-plugin
export default {"cls1":"EvaluatePublicationFinderPage-cls1_nC9","cls2":"EvaluatePublicationFinderPage-cls2_xBn EvaluatePublicationFinderPage-cls1_nC9"};